
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { authorizeUserServerSide } from 'api/firebaseAdmin';
import { withForcePlanToLoggedInUnsubs } from 'context';
import { createRedirectIfNeeded } from 'helpers';
import { basicSEO } from 'helpers/jsx';
import { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';
import useTranslation from 'next-translate/useTranslation';
import Head from 'next/head';
import CategorySectionPlaylist from '../../components/CategorySections/CategorySectionPlaylist';
import Layout from '../../components/Layout';
import { Namespace } from '../../enums/namespaces';
import { PlayBase } from '../../typings/api';
import { StaticPathParams } from '../../typings/staticPaths';

interface Props {
  plays: PlayBase[];
  countryCode: string;
}

const Playlist: NextPage<Props> = ({ plays, countryCode }) => {
  const { t } = useTranslation(Namespace.Common);

  return (
    <Layout countryCode={countryCode}>
      <Head>{basicSEO(t('seo:playlist_most_popular_title'), t('seo:playlist_most_popular_description'))}</Head>
      <CategorySectionPlaylist headline={t('common:playlist_most_popular_title')} plays={plays} />
    </Layout>
  );
};

 async function _getServerSideProps(
  ctx: GetServerSidePropsContext<StaticPathParams>,
): Promise<GetServerSidePropsResult<Props>> {
  const { apiClient, locale, countryCode } = await authorizeUserServerSide(ctx);

  const redirect = createRedirectIfNeeded(ctx, locale);
  if (redirect) {
    return redirect;
  }

  const plays = await apiClient.getPlays({ order_by: 'views' });

  return {
    props: { plays, countryCode },
  };
}

export default withForcePlanToLoggedInUnsubs(Playlist);


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/playlist/most-popular',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  